import React from 'react';
import { Accordion } from 'react-bootstrap';

const SuppliesAccordion = ({
  selectAllRef,
  headerCountLabel,
  onSelectAll,
  groupedBySupply,
  selectedPositionIds,
  onToggleSupplyGroup,
  renderRowPosition,
}) => {
  return (
    <div className="mt-2">
      <div className="d-flex align-items-center mb-2">
        <input
          ref={selectAllRef}
          type="checkbox"
          className="form-check-input"
          onChange={onSelectAll}
        />
        <span className="ms-2">{headerCountLabel}</span>
      </div>
      <Accordion alwaysOpen>
        {groupedBySupply.map((group, idx) => {
          const ids = group.positions.map(p => p.id);
          const all = ids.every(id => selectedPositionIds.includes(id));
          const some = !all && ids.some(id => selectedPositionIds.includes(id));

          const supplyName = group.supply?.name || 'Без поставки';
          const supplyId = group.supplyId === 'NO_SUPPLY' ? '—' : (group.supply?.externalId);
          const createdAt = group.supply?.time
            ? new Date(group.supply.time).toLocaleString()
            : '—';

          return (
            <Accordion.Item eventKey={`${idx}`} key={`supply-${group.supplyId}-${idx}`}>
              <Accordion.Header>
                <div className="d-flex align-items-center" style={{ gap: 12 }}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    ref={el => { if (el) el.indeterminate = some; }}
                    checked={all}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                      e.stopPropagation();
                      onToggleSupplyGroup(group);
                    }}
                  />
                  <div>
                    <div><strong>{supplyName}</strong> — {supplyId}</div>
                    <div className="text-muted" style={{ fontSize: 12 }}>{createdAt}</div>
                  </div>
                  <span className="ms-2">
                    ({ids.filter(id => selectedPositionIds.includes(id)).length}/{ids.length})
                  </span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <table className="table table-sm align-middle">
                  <thead>
                    <tr>
                      <th>Выбрать</th>
                      <th>Заказ / Отправление / Дата</th>
                      <th>Картинка</th>
                      <th>Название / Артикул</th>
                      <th>Цена</th>
                    </tr>
                  </thead>
                  <tbody>
                    {group.positions.map((p, i) => renderRowPosition(p, i))}
                  </tbody>
                </table>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
};

export default SuppliesAccordion;
